import React, { useEffect, useState } from 'react'
import { Doughnut, Chart } from 'react-chartjs-2'
// import ChartDataLabels from 'chartjs-plugin-datalabels';


const DonutChart = (props) => {

  let diff = (num1, num2) => {
    return num1 - num2
  }

  const { totalUsage, totalProduction, utility } = props

  const [usage, setUsage] = useState('')

  const [production, setProduction] = useState('')



  // round corners
  Chart.pluginService.register({
    afterUpdate: function (chart) {
      if (chart.config.options.elements.arc.roundedCornersFor !== undefined) {
        var arc = chart.getDatasetMeta(0).data[chart.config.options.elements.arc.roundedCornersFor];
        arc.round = {
          x: (chart.chartArea.left + chart.chartArea.right + chart.config.options.elements.arc.borderWidth) / 2,
          y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
          radius: (chart.outerRadius + chart.innerRadius) / 2,
          thickness: (chart.outerRadius - chart.innerRadius - (chart.config.options.elements.arc.borderWidth / 2)) / 2 - 1,
          backgroundColor: arc._model.backgroundColor
        };
      }
    },

    afterDraw: function (chart) {
      if (chart.config.options.elements.arc.roundedCornersFor !== undefined) {
        var ctx = chart.chart.ctx;
        var arc = chart.getDatasetMeta(0).data[chart.config.options.elements.arc.roundedCornersFor];
        var startAngle = Math.PI / 2 - arc._view.startAngle;
        var endAngle = Math.PI / 2 - arc._view.endAngle;

        ctx.save();
        ctx.translate(arc.round.x, arc.round.y);
        ctx.fillStyle = arc.round.backgroundColor;
        ctx.beginPath();
        ctx.arc(arc.round.radius * Math.sin(startAngle), arc.round.radius * Math.cos(startAngle), arc.round.thickness, 0, 2 * Math.PI);
        ctx.arc(arc.round.radius * Math.sin(endAngle), arc.round.radius * Math.cos(endAngle), arc.round.thickness, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }
    }

  });

  useEffect(() => {
    if (Math.round(diff(totalUsage, totalProduction) / totalUsage * 100) < 1) {
      return setUsage(0.01), setProduction(99.99)
    }
    setUsage(Math.round(diff(totalUsage, totalProduction) / totalUsage * 100))
    setProduction(Math.round(totalProduction / totalUsage * 100))
  }, [totalProduction, totalUsage])
  return (
    <>
      <Doughnut
        data={{

          labels: ['ION Solar', utility],
          datasets: [
            {
              label: 'Offset',
              datalabels: {
                display: false
              },
              data: [

                production,
                usage
              ],
              backgroundColor: [
                'rgba(65,126,238,1)',
                'rgb(238,237,237)',

              ]
            }
          ]
        }}
        options={{
          rotation: 270.2,
          tooltips: { enabled: false },
          hover: { mode: null },
          elements: {
            arc: {
              roundedCornersFor: 0,
              borderWidth: 0
            },
          },
          responsive: true,
          cutoutPercentage: 90,
          title: {
            display: false,
            text: 'Usage Offset',
            fontSize: 0,
            fontColor: '#000'
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }
        }} />
    </>
  )

}

export default DonutChart